module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setSnowflakeCredentialsCard.title":"Set Snowflake Credentials","setSnowflakeCredentialsCard.accountName":"Account Name","setSnowflakeCredentialsCard.organizationName":"Organization Name","setSnowflakeCredentialsCard.userName":"User Name","setSnowflakeCredentialsCard.password":"Password"}}')
  delete Component.options._Ctor
}
